import { NextPageContext } from 'next';
import getConfig from 'next/config';
import getUserData from 'views/AuthController/api/getUserData';
import { logInfo } from 'utils/logging';
import { profileApi } from '../index';
import { Api } from '../profile';
import GetUserProfileIncludeEnum = Api.GetUserProfileIncludeEnum;

const { publicRuntimeConfig } = getConfig();
const LOCALHOST = publicRuntimeConfig.LOCAL_HOST;
const UCHI_URL = publicRuntimeConfig.UCHI_URL;
const INTERNAL_API_MONOLITH_URL = publicRuntimeConfig.INTERNAL_API_MONOLITH_URL;

const getUser = async (ctx: NextPageContext | undefined = undefined) => {
  const isServer = typeof window === 'undefined';

  const [otvetyData, profileData] = await Promise.all([
    // Get user data from old otvety api
    getUserData(ctx),
    // Get user data from profiling
    profileApi(ctx)
      .getUserProfile(GetUserProfileIncludeEnum.Group)
      .catch((e) => logInfo(e, true)),
  ]);

  if (!otvetyData?.avatar || !profileData?.data.attributes.foreign_id) {
    logInfo(`no user info from api`);
    return null;
  }

  // AZ for different types of users (TEACHER || STUDENT)
  const testsForStudents = `&labels[]=otvety_global_student&labels[]=otvety_marathon&labels[]=otvety_topmenu_student_b2t&labels[]=otvety_topmenu_student_b2c`;
  const testsForTeachers = `&labels[]=otvety_global_teacher&labels[]=otvety_topmenu_teacher`;

  const userType = profileData.data.type;
  const azHost = LOCALHOST ? UCHI_URL : isServer ? INTERNAL_API_MONOLITH_URL : UCHI_URL;

  const userAzTests = await fetch(
    `${azHost}/api/v1/az_tests?num_id=${userType}-${
      profileData.data.attributes.foreign_id
    }${
      userType === 'student' || userType === 'parent'
        ? testsForStudents
        : userType === 'teacher'
        ? testsForTeachers
        : ''
    }`,
  )
    .then((data) => data.json())
    .catch((e) => logInfo(`AZ err: ${e}`, true));

  // B2T or B2C for user with type student
  // If user have class name in included
  const groupUser =
    userType === 'student' &&
    profileData?.included &&
    profileData?.included[0]?.attributes?.name
      ? 'B2T'
      : 'B2C';

  return {
    ...profileData,
    ...otvetyData,
    azTests: {
      ...userAzTests,
    },
    groupUser,
  };
};

export default getUser;
